import styled from 'styled-components';

const Container = styled.div`
  .label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 15px;
    
    .row {
      width: 125px;

      h2 {
        font-size: 0.95rem;
        font-weight: 700;
        color: #999;
        text-transform: uppercase;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

  @media screen and (max-width: 767px) {
    .label { display: none }
  }
`;

export default Container;
